import { render } from "./SegmentedTabPage.vue?vue&type=template&id=66b0d33e&scoped=true"
import script from "./SegmentedTabPage.vue?vue&type=script&lang=js"
export * from "./SegmentedTabPage.vue?vue&type=script&lang=js"

import "./SegmentedTabPage.vue?vue&type=style&index=0&id=66b0d33e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b0d33e"]])

export default __exports__